<template>
    <p class="mt-2 text-sm text-gray-700">
        {{ $t("event_types.event_detail.assign_to_round_robin_first.part_1") }}
        <button
            @click="emit('update-tab')"
            class="text-underline text-blue-500"
        >
            {{
                $t(
                    "event_types.event_detail.assign_to_round_robin_first.part_2",
                )
            }}</button
        >.
    </p>
</template>

<script lang="ts" setup>
const emit = defineEmits(["update-tab"]);
</script>
